import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BpgEventsService } from '../bpg-events.service';
import { Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingDTOModel,FilterModel} from "../../bpg-common/services/data.services";

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AmazingTimePickerService } from 'amazing-time-picker';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
@Component({
  selector: 'app-bpg-create-and-edit-event',
  templateUrl: './bpg-create-and-edit-event.component.html',
  styleUrls: ['./bpg-create-and-edit-event.component.css']
})
export class BpgCreateAndEditEventComponent implements OnInit {
  eventDetailsForm: FormGroup;
  chaptersList: any;
  eventTypeList: any;
  timeZoneList: any;
  hoshinList: any;
  dateToday: any;
  RegMinDate: any;
  fileName = "Upload document";
  fileExtension: any;
  fileExtensionError = false;
  fileSize: number;
  fileSizeExtensionError = false;
  maxAttendeesNumberError = false;
  loginData = JSON.parse(localStorage.getItem('loginData'));
  userAndRoleIdDTO = {
    userId: this.loginData['userId'],
    roleId: localStorage.getItem('adminId')
  }
  chapterDropDownList: any;
  eventTypeDropDownList: any;
  HoshinDropDownList: any;
  selectedFile: File = null;
  fileList: File[] = [];
  eventFormValues: Object;
  alertSuccess: boolean;
  editEventData: any;
  actionTitle: any;
  buttonType: any;
  startTimeGreaterErrorMessage = false;
  startTimeEqualErrorMessage = false;
  startDateGreaterErrorMessage = false;
  timeOutError = false;
  startDateGreaterThanCreateDateErrorMessage = false;
  endDateGreaterThanCreateDateErrorMessage = false;
  minDurationErrorMessage = false;
  msg1: string;
  msg2: string;
  method: string;
  param: string
  landingDTOModel:LandingDTOModel = new LandingDTOModel();
  filter : FilterModel =  new FilterModel();
  alertSuccessOnSave:boolean;
  deviceInfo = null;
  tomorrowDate: any;
  previousDate:any;
  regEndMinDate:any;
  eventDate:any;
  adminId:any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  alertFailure: boolean;
 occurenceType  = 'once';
 eventDayList: any;
 eventGroupId : any;
 weekday: any;
 eventEndDate: any;
 eventSeries : any;
  eventDateList =  [];
  weekdayList = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  minEndDate : any;
  eventIdList : any;
  selectedweekList = [];
  startdateString : string;
  enddateString : string;
  //maxAttendeesEnable:boolean = false;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  maxAttendeecePreviousValue:number;
  todaysDate : any = new Date();
  startTimeLessThanCurrentTime  = false;
  endTimeLessThanCurrentTime  =  false;
  oldMaxAttendeece :any
  isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  uploadFlag = 'create-event';
  awsUrls : any;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  naacList: any = [];
  editEvent: boolean;
  dateFormatConstant = 'MM-dd-yyyy';
  dateTimeFormatConstant =  "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
  todaysDateConstant = 'yyyy-MM-dd';
  dataToggleConstant = 'data-toggle';
  dataTargetConstant = 'data-target';
  /**
  * @class BpgCreateAndEditEventComponent
  * @constructor
  */
  constructor(private readonly formBuilder: FormBuilder,
    private readonly bpgEventService: BpgEventsService,
    private readonly router: Router,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly location: Location,
    private readonly  datePipe: DatePipe,
    private readonly _picker: BsDatepickerModule,
    private readonly atp: AmazingTimePickerService,
    private readonly environment : EnvironmentConfiguration,
    private readonly uploadService : UploadService,
    private readonly bpgCommonService : BpgCommonService,
    private readonly selfService : SelfService) { }

  ngOnInit() {
    this.regEndMinDate = new Date();
    if(this.isIEOrEdge){
      this.deviceInfo = 'IE';
    } else {
      this.deviceInfo = 'Chrome';
    }
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
      }
    }

    window.scrollTo(0, 0);
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin')==='true'){
      this.isbpgLeadAdmin = true;
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    if(this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && this.adminId !== "4" && !this.isbpgAdmin && !this.isbpgLeadAdmin && !this.isNaacAdmin)
    {
      this.router.navigate(['/site-home']);
    }

    this.bpgCommonService.getSessionToken();

    this.dateToday = new Date();
    this.tomorrowDate = new Date(this.dateToday.setDate(this.dateToday.getDate() + 1));
    this.RegMinDate = new Date();
    this.editEventData = JSON.parse(sessionStorage.getItem('editEventData')); 

    this.bpgEventService.getEventTypeListForDropDown().subscribe(data => {
      this.eventTypeDropDownList = data;
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    });

    this.bpgEventService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterDropDownList = data;
      this.chapterDropDownList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}`; return i; })
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }    
    });
    this.getAllBpg();
    this.buildForms();

    this.timeZoneList = [
      {name: "EST (Eastern Standard Time)", value:"US/Eastern"},
      {name: "CST (Central Standard Time)", value:"US/Central"},
      {name: "MST (Mountain Standard Time)", value:"US/Mountain"},
      {name: "PST (Pacific Standard Time)", value:"US/Pacific"}
    ]
    this.eventDetailsForm.get('occurenceType').valueChanges
    .subscribe(value => {

      if(value!=='once') {
        
        this.eventDetailsForm.get('eventEndDate').setValidators(Validators.required)
      } else {
        
        this.eventDetailsForm.get('eventEndDate').clearValidators();
        this.eventDetailsForm.get('eventEndDate').setErrors(null)  ;
      }
    }
);


  }


  /** For building add event form
     * @class BpgCreateAndEditEventComponent
     * @method buildForms
     */
  private buildForms(): void {

    this.eventDetailsForm = this.formBuilder.group({
      eventId: null,
      chapterId: [null, Validators.required],
      eventTypeId: [null, Validators.required],
      isHoshin: [true, Validators.required],
      hoshinId: [null, Validators.required],
      explainNonHoshin: [null, Validators.required],
      eventName: [null, Validators.required],
      venue: null,
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
      eventCreateDate: [null, Validators.required],
      eventEndDate:[null],
      
      eventDateList: null,
      description: [null, Validators.required],
      occurenceType : 'once',  
      eventSeries : new Date(),
      eventGroupId: null,
      actionTitle : null,
      todaysDate : null,
      chooseday: null,
      weekdayList:null,
    
      timeZone: [null, Validators.required],
      eventCoordinatorEmail: [null, Validators.email],
      maxAttendeece: [null, Validators.required],

      virtualMeetingLinks: null,
      virtualFlag : false,
      registrationStartDate: new Date(),
      registrationEndDate: null,
      eventDocumentUrl: null,
      isSubmitted: false,
      createdByAdmin: this.loginData['userId'],
      eventStatus: null,
      eventCreatedDateString:null,
      eventEndDateString: null,
      registrationStartDateString:null,
      registrationEndDateString:null,
      eventStartTimeString:null,
      eventEndTimeString:null,
      sendEmail:false,
      naacId:null,
      eventLevelFlag: true,
      lastUpdatedByEmailId:this.loginData['emailId']
    });
    

    if (this.editEventData != null) {
      this.editEventData.startTime = this.formatTimeShow(this.editEventData.startTime);

      this.occurenceType = this.editEventData.occurenceType;
     
      if(this.editEventData.edit === 'single')
      {
        this.actionTitle = "EDIT";
      }
      if(this.editEventData.edit === 'multi')
      {
        this.actionTitle = "EDITALL";
        const tempdate = this.editEventData.eventSeries.replace('-','/');
        this.minEndDate = new Date(tempdate);
    
      }
      this.filter.chapterId=this.editEventData.chapterId;
      // newly added filter
      this.filter.hoshinId = this.editEventData.hoshinId;
      this.maxAttendeecePreviousValue = this.editEventData.maxAttendeece;
      this.oldMaxAttendeece= this.editEventData.maxAttendeeceOld;
      this.landingDTOModel.filter = this.filter;
      this.bpgEventService.getHoshinListForDropDown( this.landingDTOModel).subscribe(data => {
        this.HoshinDropDownList = data;
      }, err => {  
        this.spinner.hide();
        if(err.value.statusText === ConstantValues.unknownError){
                    this.timeOutError = true;
                  }
      });
      if (this.editEventData.registrationStartDate != null && this.editEventData.registrationStartDate !== undefined) {
        this.editEventData.registrationStartDate = this.datePipe.transform(this.editEventData.registrationStartDate, this.dateFormatConstant); 
        this.setRegEndMinDate(this.editEventData.registrationStartDate);
      }

      if (this.editEventData.registrationEndDate != null && this.editEventData.registrationEndDate !== undefined) {
        this.editEventData.registrationEndDate = this.datePipe.transform(this.editEventData.registrationEndDate, this.dateFormatConstant); 

      }

      if (this.editEventData.eventCreateDate != null && this.editEventData.eventCreateDate !== undefined) {
        this.editEventData.eventCreateDate =this.datePipe.transform(this.editEventData.eventCreateDate, this.dateFormatConstant);
      }
      if (this.editEventData.eventEndDate != null && this.editEventData.eventEndDate !== undefined) {
          this.editEventData.eventEndDate = this.datePipe.transform(this.editEventData.eventEndDate, this.dateFormatConstant); 
          
      
      }
      if (this.editEventData.eventSeries != null && this.editEventData.eventSeries !== undefined) {
        this.editEventData.eventSeries =this.datePipe.transform(this.editEventData.eventSeries, this.dateFormatConstant);
      }
      this.setRegDate(this.editEventData.eventCreateDate);
      this.setEndDate(this.editEventData.eventEndDate);
      
      if (this.editEventData.timeZone != null && this.editEventData.timeZone !== undefined) {
        this.editEventData.timeZone = this.editEventData.timeZone.replace(/\s/g, "");
      }

      if (this.editEventData.isHoshin === true) {        
        this.editEventData.explainNonHoshin = null;
        this.eventDetailsForm.controls['explainNonHoshin'].disable();
        this.eventDetailsForm.controls['hoshinId'].enable();
      } else if (this.editEventData.isHoshin === false) {
        this.editEventData.hoshinId = null;
        this.eventDetailsForm.controls['hoshinId'].disable();
        this.eventDetailsForm.controls['explainNonHoshin'].enable();
      }
      if (this.editEventData.eventDocumentUrl != null) {
        this.fileName = this.editEventData.eventDocumentUrl;
      }
      


      this.eventDetailsForm.patchValue(this.editEventData);
      if(this.eventDetailsForm.value.eventLevelFlag === false)

  {
    
    for (const key in this.eventDetailsForm.controls) {
      this.eventDetailsForm.get(key).clearValidators();
      this.eventDetailsForm.get(key).updateValueAndValidity();
      this.eventDetailsForm.get(key).setErrors(null);

  }

  this.eventDetailsForm.controls['eventLevelFlag'].setValidators([Validators.required])
  this.eventDetailsForm.get('eventLevelFlag').updateValueAndValidity();
  this.eventDetailsForm.controls['startTime'].setValidators([Validators.required])
  this.eventDetailsForm.get('startTime').updateValueAndValidity();
  this.eventDetailsForm.controls['endTime'].setValidators([Validators.required])
  this.eventDetailsForm.get('endTime').updateValueAndValidity();
  this.eventDetailsForm.controls['eventCreateDate'].setValidators([Validators.required])
  this.eventDetailsForm.get('eventCreateDate').updateValueAndValidity();
  this.eventDetailsForm.controls['timeZone'].setValidators([Validators.required])
  this.eventDetailsForm.get('timeZone').updateValueAndValidity();
  this.eventDetailsForm.controls['eventName'].setValidators([Validators.required])
  this.eventDetailsForm.get('eventName').updateValueAndValidity();
  this.eventDetailsForm.controls['maxAttendeece'].setValidators([Validators.required])
  this.eventDetailsForm.get('maxAttendeece').updateValueAndValidity();
  this.editEvent = true
}


    } else {
      this.actionTitle = "CREATE";
      this.editEvent = false

      this.eventDetailsForm.controls['explainNonHoshin'].disable();
      if(this.adminId === '4')
      {
        this.eventDetailsForm.get('eventLevelFlag').setValue(false);
        for (const key in this.eventDetailsForm.controls) {
          this.eventDetailsForm.get(key).clearValidators();
          this.eventDetailsForm.get(key).updateValueAndValidity();
          this.eventDetailsForm.get(key).setErrors(null);
  
      }
      this.eventDetailsForm.controls['naacId'].setValidators([Validators.required])
      this.eventDetailsForm.get('naacId').updateValueAndValidity();
      this.eventDetailsForm.controls['eventLevelFlag'].setValidators([Validators.required])
      this.eventDetailsForm.get('eventLevelFlag').updateValueAndValidity();
      this.eventDetailsForm.controls['startTime'].setValidators([Validators.required])
      this.eventDetailsForm.get('startTime').updateValueAndValidity();
      this.eventDetailsForm.controls['endTime'].setValidators([Validators.required])
      this.eventDetailsForm.get('endTime').updateValueAndValidity();
      this.eventDetailsForm.controls['eventCreateDate'].setValidators([Validators.required])
      this.eventDetailsForm.get('eventCreateDate').updateValueAndValidity();
      this.eventDetailsForm.controls['timeZone'].setValidators([Validators.required])
      this.eventDetailsForm.get('timeZone').updateValueAndValidity();
      this.eventDetailsForm.controls['eventName'].setValidators([Validators.required])
      this.eventDetailsForm.get('eventName').updateValueAndValidity();
      this.eventDetailsForm.controls['maxAttendeece'].setValidators([Validators.required])
      this.eventDetailsForm.get('maxAttendeece').updateValueAndValidity();
  
   }
      
    }
    
  }

  /** For getting list of bpgs
     * @class BpgCreateAndEditEventComponent
     * @method getAllBpg
     */
  getAllBpg() {
    const LandingPaginationDTO = {
      "filter": {
        "naacFlag": "naacSelfService",
        "adminId": this.adminId,
        "userId": this.loginData.userId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": ""

    }

    this.selfService.getnaacAffinityList(LandingPaginationDTO).subscribe(data => {
      this.naacList = data;
      if(this.adminId === '4' || this.isNaacAdmin && this.naacList.length > 0)
      {
        this.eventDetailsForm.controls['naacId'].setValue(this.naacList[0].naacId); 
      }
    })
  }
  /** converting 12 hour time to 24 hour time format
  * @class BpgCreateAndEditEventComponent
  * @method convertTimeTo24Hours
  */
  convertTimeTo24Hours(time) {
    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s([^\s]*)$/)[1];
    if (AMPM === "PM" && hours < 12){ hours = hours + 12;}
    if (AMPM === "AM" && hours === 12) {hours = hours - 12;}
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) {sHours = "0" + sHours;}
    if (minutes < 10){ sMinutes = "0" + sMinutes;}
    return `${sHours}:${sMinutes}`;
  }

  /** adding time to event date
* @class BpgCreateAndEditEventComponent
* @method addTimeToEventDate
*/
  addTimeToEventDate(date, time) {
    const dateTime = new Date(date);
    dateTime.setHours(time.split(':')[0]);
    dateTime.setMinutes(time.split(':')[1]);
    dateTime.setSeconds(0);

    const date1 = new Date(dateTime);
    return this.datePipe.transform(new Date(date1).toString(),this.dateTimeFormatConstant);
  }


  /** To set filename
* @class BpgCreateAndEditEventComponent
* @method onFileSelected
*/

  public onFileSelected(event) {
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
      this.fileExtension = this.fileName.split('.').pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) { 

        if (this.fileSize > 5242880) {
          this.fileSizeExtensionError = true;
        } else {
          this.fileExtensionError = false;
          this.fileSizeExtensionError = false;
          this.selectedFile = event.target.files[0] as File;
          this.eventDetailsForm.value.eventDocumentUrl = this.selectedFile.name;
        }
      } else {
        this.fileExtensionError = true;
      }
    }
  }


  removeFile(){
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.selectedFile = null;
    this.fileName = "Upload document";
    this.eventDetailsForm.value.eventDocumentUrl = null;
  }

  /** checks if word exists in array
  * @class BpgCreateAndEditEventComponent
  * @method isInArray
  */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  /** To save event form
 * @class BpgCreateAndEditEventComponent
 * @method saveEvent
 */

  saveEvent(action) {
    this.timeOutError = false;
    this.startTimeGreaterErrorMessage = false;
    this.startTimeEqualErrorMessage = false;
    this.startDateGreaterErrorMessage = false;
    this.minDurationErrorMessage = false;
    this.startDateGreaterThanCreateDateErrorMessage = false;
    this.endDateGreaterThanCreateDateErrorMessage = false;
    this.maxAttendeesNumberError = false;
    this.startTimeLessThanCurrentTime = false;
    this.endTimeLessThanCurrentTime = false;
   

    if(this.eventDetailsForm.value.startTime.match(/^\s(.*)$/) === null){
      this.eventDetailsForm.value.startTime = this.formatTimeShow(this.eventDetailsForm.value.startTime);
    }
    if(this.eventDetailsForm.value.endTime.match(/^\s(.*)$/) === null){
      this.eventDetailsForm.value.endTime = this.formatTimeShow(this.eventDetailsForm.value.endTime);

    }

 
    this.eventDetailsForm.value.startTime = this.convertTimeTo24Hours(this.eventDetailsForm.value.startTime);
      

    this.eventDetailsForm.value.endTime = this.convertTimeTo24Hours(this.eventDetailsForm.value.endTime);

  
    if (this.eventDetailsForm.value.startTime > this.eventDetailsForm.value.endTime) {
     
      this.startTimeGreaterErrorMessage = true;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },500);
      return
    } else if (this.eventDetailsForm.value.startTime === this.eventDetailsForm.value.endTime) {
      this.startTimeEqualErrorMessage = true;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },500);
      return
    }
   
    if(this.actionTitle=== 'EDITALL')
    {
     this.minEndDate =  this.eventDetailsForm.value.eventSeries; 
   } 
   if(this.eventDetailsForm.value.occurenceType != null && this.eventDetailsForm.value.eventCreateDate!==null)
      { 
        if(this.actionTitle=== 'EDITALL')
        {
          this.eventDetailsForm.value.eventCreateDate =  this.eventDetailsForm.value.eventSeries; 
        }
        this.eventDetailsForm.value.selectedweekList = ['NA'];
       this.eventDetailsForm.value.todaysDate = this.datePipe.transform(new Date(),this.todaysDateConstant);

       let startdatetoDate = new Date(this.eventDetailsForm.value.eventCreateDate );
       let enddatetoDate;
       let tempstring;
       if(this.eventDetailsForm.value.eventEndDate != null)
       {  
         enddatetoDate = new Date(this.eventDetailsForm.value.eventEndDate );
       }

       if(this.actionTitle=== 'CREATE')
       {
       const eventGroupId = new Date().valueOf();
       this.eventGroupId = eventGroupId.toString();
       this.eventDetailsForm.value.eventGroupId = this.eventGroupId;
       }
       startdatetoDate = new Date( startdatetoDate.setHours(0));
       startdatetoDate = new Date( startdatetoDate.setMinutes(0));
       startdatetoDate = new Date( startdatetoDate.setSeconds(0));
       if(this.eventDetailsForm.value.occurenceType === 'once')
        {
          const startdate = this.datePipe.transform(this.eventDetailsForm.value.eventCreateDate,this.todaysDateConstant)
          this.eventDateList.push(startdate);
         }

        if(this.eventDetailsForm.value.occurenceType === 'monthly'){
      
          while(startdatetoDate<=enddatetoDate)
          {
            tempstring = this.datePipe.transform(startdatetoDate,this.todaysDateConstant);
            this.eventDateList.push(tempstring);
            const monthValue = startdatetoDate.getMonth();
            startdatetoDate = new Date(startdatetoDate.setMonth(monthValue+1));
          }
        }

        if(this.eventDetailsForm.value.occurenceType === 'quarterly'){
          while(startdatetoDate<=enddatetoDate)
          {
            tempstring = this.datePipe.transform(startdatetoDate,this.todaysDateConstant);
            this.eventDateList.push(tempstring);
            const monthValue = startdatetoDate.getMonth();
            startdatetoDate = new Date(startdatetoDate.setMonth(monthValue+3));
          }
        }
  
      }
      
    if (typeof this.eventDetailsForm.value.registrationStartDate == 'string') {
      this.eventDetailsForm.value.registrationStartDate = this.eventDetailsForm.value.registrationStartDate.replace('-','/');
      this.eventDetailsForm.value.registrationStartDate = this.eventDetailsForm.value.registrationStartDate.replace('-','/');
      this.eventDetailsForm.value.registrationStartDate = new Date(this.eventDetailsForm.value.registrationStartDate);
    }
    
    if (typeof this.eventDetailsForm.value.registrationEndDate == 'string') {
      this.eventDetailsForm.value.registrationEndDate = this.eventDetailsForm.value.registrationEndDate.replace('-','/');
      this.eventDetailsForm.value.registrationEndDate = this.eventDetailsForm.value.registrationEndDate.replace('-','/');
      this.eventDetailsForm.value.registrationEndDate = new Date(this.eventDetailsForm.value.registrationEndDate);
    }
      
    if (typeof this.eventDetailsForm.value.eventCreateDate == 'string') {
      this.eventDetailsForm.value.eventCreateDate = this.eventDetailsForm.value.eventCreateDate.replace('-','/');
      this.eventDetailsForm.value.eventCreateDate = this.eventDetailsForm.value.eventCreateDate.replace('-','/');
      this.eventDetailsForm.value.eventCreateDate = new Date(this.eventDetailsForm.value.eventCreateDate);
    } 
    if (typeof this.eventDetailsForm.value.eventEndDate == 'string') {
      this.eventDetailsForm.value.eventEndDate = this.eventDetailsForm.value.eventEndDate.replace('-','/');
      this.eventDetailsForm.value.eventEndDate = this.eventDetailsForm.value.eventEndDate.replace('-','/');
      this.eventDetailsForm.value.eventEndDate = new Date(this.eventDetailsForm.value.eventEndDate);
    } 
    if (typeof this.eventDetailsForm.value.eventSeries == 'string') {
      this.eventDetailsForm.value.eventSeries = this.eventDetailsForm.value.eventSeries.replace('-','/');
      this.eventDetailsForm.value.eventSeries = this.eventDetailsForm.value.eventSeries.replace('-','/');
      this.eventDetailsForm.value.eventSeries = new Date(this.eventDetailsForm.value.eventSeries);
    } 
    if ((this.eventDetailsForm.value.eventLevelFlag && this.datePipe.transform(this.eventDetailsForm.value.registrationStartDate,this.dateTimeFormatConstant) > this.datePipe.transform(this.eventDetailsForm.value.eventCreateDate,this.dateTimeFormatConstant))) {
      
      this.startDateGreaterThanCreateDateErrorMessage = true;
     return
    }
    if (this.eventDetailsForm.value.eventLevelFlag && this.eventDetailsForm.value.registrationStartDate > this.eventDetailsForm.value.registrationEndDate) {
      this.startDateGreaterErrorMessage = true;
     return
    }

    if (this.datePipe.transform(this.eventDetailsForm.value.registrationEndDate,this.dateTimeFormatConstant) > this.datePipe.transform(this.eventDetailsForm.value.eventCreateDate,this.dateTimeFormatConstant)) {
      this.endDateGreaterThanCreateDateErrorMessage = true;
     return
    }


    this.eventDetailsForm.value.startTime = this.addTimeToEventDate(this.eventDetailsForm.value.eventCreateDate, this.eventDetailsForm.value.startTime)

    this.eventDetailsForm.value.endTime = this.addTimeToEventDate(this.eventDetailsForm.value.eventCreateDate, this.eventDetailsForm.value.endTime)
    const duration = this.eventDetailsForm.value.endTime.valueOf() - this.eventDetailsForm.value.startTime.valueOf();

    if(this.eventDetailsForm.value.startTime < this.datePipe.transform(new Date(),this.dateTimeFormatConstant)){
      this.startTimeLessThanCurrentTime = true;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },200);
      return
    }
    if(this.eventDetailsForm.value.endTime < this.datePipe.transform(new Date(),this.dateTimeFormatConstant)){
      this.endTimeLessThanCurrentTime = true;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },200);
      return
    }   
    if(duration < 3600000){
      this.minDurationErrorMessage = true;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },200);
      return
    }

    
    const registrationStartDate = new Date(this.eventDetailsForm.value.registrationStartDate);
    const registrationStartDateString = `${registrationStartDate.getFullYear()}-${registrationStartDate.getMonth() + 1}-${registrationStartDate.getDate()}`;
    this.eventDetailsForm.value.registrationStartDate = registrationStartDateString;
    const registrationEndDate = new Date(this.eventDetailsForm.value.registrationEndDate);
    const registrationEndDateString = `${registrationEndDate.getFullYear()}-${registrationEndDate.getMonth() + 1}-${registrationEndDate.getDate()}`;
    this.eventDetailsForm.value.registrationEndDate = registrationEndDateString;

    const eventCreateDate = new Date(this.eventDetailsForm.value.eventCreateDate);
    const eventCreateDateString = `${eventCreateDate.getFullYear()}-${eventCreateDate.getMonth() + 1}-${eventCreateDate.getDate()}`;
    this.eventDetailsForm.value.eventCreateDate = eventCreateDateString;
    this.eventDetailsForm.value.eventCreatedDateString = eventCreateDateString;
    if(this.eventDetailsForm.value.eventEndDate != null)
    {
      const eventEndDateString = `${eventCreateDate.getFullYear()}-${eventCreateDate.getMonth() + 1}-${eventCreateDate.getDate()}`;
      this.eventDetailsForm.value.eventEndDate = eventEndDateString;
      this.eventDetailsForm.value.eventEndDateString = eventEndDateString;
    }

    this.eventDetailsForm.value.registrationStartDateString = registrationStartDateString;
    this.eventDetailsForm.value.registrationEndDateString = registrationEndDateString;
    this.eventDetailsForm.value.eventStartTimeString = this.eventDetailsForm.value.startTime;
    this.eventDetailsForm.value.eventEndTimeString = this.eventDetailsForm.value.endTime;
   
    this.spinner.show();
    if (action === 'save') {
      this.eventDetailsForm.value.isSubmitted = false;
      this.eventDetailsForm.value.eventStatus = 'NEW';
    } else if (action === 'submit') {
      this.eventDetailsForm.value.isSubmitted = true;
      this.eventDetailsForm.value.eventStatus = 'SCHEDULED';
    }

	if (this.selectedFile != null) {
    this.eventDetailsForm.value.eventDocumentUrl = this.selectedFile.name;
    }

    if(this.eventDateList!=null)
    {
      this.eventDetailsForm.value.eventDateList = this.eventDateList;
    }
    if(this.eventDetailsForm.value.occurenceType === 'once' && this.eventDetailsForm.value.eventLevelFlag)
    {
      this.eventDetailsForm.value.eventEndDate =  this.eventDetailsForm.value.eventCreateDate;
      this.eventDetailsForm.value.eventEndDateString =  this.eventDetailsForm.value.eventCreatedDateString ;
    }

      this.eventDetailsForm.value.actionTitle = this.actionTitle;
      if( this.eventDetailsForm.value.actionTitle === 'EDITALL'){
      this.eventDetailsForm.value.eventId = null;
      }
    const eventFormData = {...this.eventDetailsForm.value};
    
    this.bpgEventService.saveEvent(eventFormData).subscribe(data => {
      this.eventDetailsForm.controls['eventId'].setValue(data.eventId);

      const eventData = data;
      const uploadData =
      {
        'category': 'uploadDocument',
      }
      if (this.selectedFile != null) {
        this.fileList.push(this.selectedFile);
        const eventIdList = eventData.eventIdList
        for(let i = 0 ; i < eventIdList.length ; i++)
        {
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
        await this.uploadService.getPresignedUrl(this.selectedFile,this.awsUrls,eventIdList[i],this.uploadFlag);
            if(i === eventIdList.length - 1)
            {
              this.spinner.hide();
              if (action === 'save') {
                this.alertSuccessOnSave = true;
                this.alertSuccess = false;
              } else if (action === 'submit') {
                this.alertSuccess = true;
                this.alertSuccessOnSave = false;
              }
              if(data === null){
                this.alertFailure = true;
                }
              setTimeout(() => {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
              },200);
            }


  
          }, err => {
            this.spinner.hide();
            if(err.value.statusText === ConstantValues.unknownError){
              this.timeOutError = true;
            }
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            },200);
          });
        }
    
      }
      else {
        this.spinner.hide();
        if (action === 'save') {
          this.alertSuccessOnSave = true;
          this.alertSuccess = false;
        } else if (action === 'submit') {
          this.alertSuccess = true;
          this.alertSuccessOnSave = false;

        }
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        },200);
       
      }
      setTimeout(() => {
        this.location.back();
      },2500);
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
        this.timeOutError = true;
      }
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      },200);

    });

  }


  changeEventLevelFlag(data)
  {
    if(data)
    {
      this.eventDetailsForm.controls['chapterId'].setValidators([Validators.required])
      this.eventDetailsForm.controls['eventTypeId'].setValidators([Validators.required])
      this.eventDetailsForm.controls['isHoshin'].setValidators([Validators.required])
      this.eventDetailsForm.controls['hoshinId'].setValidators([Validators.required])
      this.eventDetailsForm.controls['explainNonHoshin'].setValidators([Validators.required])
      this.eventDetailsForm.controls['eventName'].setValidators([Validators.required])

      this.eventDetailsForm.controls['startTime'].setValidators([Validators.required])
      this.eventDetailsForm.controls['endTime'].setValidators([Validators.required])
      this.eventDetailsForm.controls['eventCreateDate'].setValidators([Validators.required])

   
      this.eventDetailsForm.controls['description'].setValidators([Validators.required])

    
      this.eventDetailsForm.controls['timeZone'].setValidators([Validators.required])
      this.eventDetailsForm.controls['eventCoordinatorEmail'].setValidators([Validators.required])
      this.eventDetailsForm.controls['maxAttendeece'].setValidators([Validators.required])
      this.eventDetailsForm.get('naacId').clearValidators();
      this.eventDetailsForm.get('naacId').updateValueAndValidity();
      this.eventDetailsForm.get('naacId').setErrors(null);
    }
    else{

      for (const key in this.eventDetailsForm.controls) {
        this.eventDetailsForm.get(key).clearValidators();
        this.eventDetailsForm.get(key).updateValueAndValidity();
        this.eventDetailsForm.get(key).setErrors(null);

    }
    this.eventDetailsForm.controls['naacId'].setValidators([Validators.required])
    this.eventDetailsForm.get('naacId').updateValueAndValidity();
    this.eventDetailsForm.controls['eventLevelFlag'].setValidators([Validators.required])
    this.eventDetailsForm.get('eventLevelFlag').updateValueAndValidity();
    this.eventDetailsForm.controls['startTime'].setValidators([Validators.required])
    this.eventDetailsForm.get('startTime').updateValueAndValidity();
    this.eventDetailsForm.controls['endTime'].setValidators([Validators.required])
    this.eventDetailsForm.get('endTime').updateValueAndValidity();
    this.eventDetailsForm.controls['eventCreateDate'].setValidators([Validators.required])
    this.eventDetailsForm.get('eventCreateDate').updateValueAndValidity();
    this.eventDetailsForm.controls['timeZone'].setValidators([Validators.required])
    this.eventDetailsForm.get('timeZone').updateValueAndValidity();
    this.eventDetailsForm.controls['eventName'].setValidators([Validators.required])
    this.eventDetailsForm.get('eventName').updateValueAndValidity();
    this.eventDetailsForm.controls['maxAttendeece'].setValidators([Validators.required])
    this.eventDetailsForm.get('maxAttendeece').updateValueAndValidity();

 }
}

  /** To disable form inputs based on hoshin selection
* @class BpgCreateAndEditEventComponent
* @method disableInputBasedOnSelection
*/
  public disableInputBasedOnSelection(hoshinValue) {
    if (hoshinValue === true) {      
      this.eventDetailsForm.controls['explainNonHoshin'].setValue(null);
      this.eventDetailsForm.controls['explainNonHoshin'].disable();
      this.eventDetailsForm.controls['hoshinId'].enable();
    } else {
      this.eventDetailsForm.controls['hoshinId'].setValue(null);
      this.eventDetailsForm.controls['hoshinId'].disable();
      this.eventDetailsForm.controls['explainNonHoshin'].enable();

    }
  }

  /** to select cancel
  * @class BpgMembershipPreviewComponent
  * @method cancelClick
  */
  cancelClick() {
    this.method = "navigate";
    this.param = '';
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
  }

 /** to select cancel
  * @class BpgMembershipPreviewComponent
  * @method toggleCheckbox
  */
 toggleCheckbox(event,dayname)
  {
    
    if (event.target.checked) {
     this.selectedweekList.push(dayname);
  }
  else{
    this.selectedweekList =  this.selectedweekList.filter(m=>m!==dayname);
    
  }
}

  /** to select confirm
    * @class BpgMembershipPreviewComponent
    * @method saveClick
    */
  saveClick() {

    this.maxAttendeesNumberError = false;
    document.getElementById('saveButton').setAttribute(this.dataToggleConstant,'modal');
    document.getElementById('saveButton').setAttribute(this.dataTargetConstant,'#myModal');
    if(this.oldMaxAttendeece > 0)
   {
  if((this.actionTitle === "EDIT" || this.actionTitle === "EDITALL" ) && (this.eventDetailsForm.value.maxAttendeece < this.oldMaxAttendeece)){

      document.getElementById('saveButton').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveButton').removeAttribute(this.dataTargetConstant);
      this.maxAttendeesNumberError = true;
      return
    }
  }

    this.method = "saveEvent";
    this.param = "save";
    this.msg1 = " Do you want to save this event ?";
  }

  submitClick() {

    this.maxAttendeesNumberError = false;
    document.getElementById('saveSubmitButton').setAttribute(this.dataToggleConstant,'modal');
    document.getElementById('saveSubmitButton').setAttribute(this.dataTargetConstant,'#myModal');
    if(this.oldMaxAttendeece > 0)
    {
      if((this.actionTitle === "EDIT" || this.actionTitle === "EDITALL" ) && (this.eventDetailsForm.value.maxAttendeece < this.oldMaxAttendeece)){
      document.getElementById('saveSubmitButton').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveSubmitButton').removeAttribute(this.dataTargetConstant);
      this.maxAttendeesNumberError = true;
      return
    }
  }

    this.method = "saveEvent";
    this.param = "submit";
    this.msg1 = " Do you want to submit this event ?";
  }

  navigate() {
    sessionStorage.setItem(this.buttonType, "CANCEL");
    // this.router.navigate(['events']);
    this.location.back();
    window.scrollTo(0, 0);
  }

  onChapterSelection(event){
    this.filter.chapterId=event.chapterId;
    this.landingDTOModel.filter = this.filter;
    this.bpgEventService.getHoshinListForDropDown(this.landingDTOModel).subscribe(data => {
      this.HoshinDropDownList = data;
    }, err => {
      this.spinner.hide();
      if(err.value.statusText === ConstantValues.unknownError){
            this.timeOutError = true;
          }
    });
  }
setEndDate(date)
{
  this.eventDetailsForm.value.eventEndDate = new Date(date);
}
setEventDate(date)
{
  if(this.actionTitle === 'EDITALL')
  {
    this.minEndDate = date;
  date =  new Date(date);
  this.minEndDate = date;
}}
  setRegDate(date)
  {
    this.eventDate=date;
    date =  new Date(date);
    this.previousDate = date;
    if(this.actionTitle === 'CREATE')
    {
      this.minEndDate = date;
      const regEndDate = new Date(date)
      regEndDate.setDate(regEndDate.getDate() - 1);
      this.eventDetailsForm.get('registrationEndDate').patchValue(regEndDate);
      this.eventDetailsForm.value.registrationEndDate = new Date(regEndDate); 
      this.previousDate =  regEndDate
      this.eventDetailsForm.get('registrationEndDate').setErrors(null);          
    }

  }

  setRegEndMinDate(minDate){
    this.regEndMinDate = new Date(minDate);
  }


  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
        const { cell, isHovered } = hoverEvent;

        if ((isHovered &&
          !!navigator.platform &&
          /iPad|iPhone|iPod/.test(navigator.platform)) &&
          'ontouchstart' in window
        ) {
            (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
        }

        return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
    
}

openStart(_ev: any) {
  const amazingTimePicker = this.atp.open({arrowStyle : {background:'#b62027'}});
  amazingTimePicker.afterClose().subscribe(time => {
    const t = this.formatTimeShow(time)
    this.eventDetailsForm.controls['startTime'].setValue(t);
  });
}

openEnd(_ev: any) {
  const amazingTimePicker = this.atp.open({arrowStyle : {background:'#b62027'}});
  amazingTimePicker.afterClose().subscribe(time => {
   const t = this.formatTimeShow(time)
    this.eventDetailsForm.controls['endTime'].setValue(t);
  });
}



formatTimeShow (time) {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value

    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
    if(time[0] < 10)
    {
       time[0] = '0'+time[0];
    }
  }
  return time.join (''); // return adjusted time or original string
}

}
